import { api } from "@/lib/api";

let cache = null;
export const loadWa = () => (cache ||= api.get("/settings/whatsapp").then((r) => r.data).catch((e) => { cache = null; throw e; }));
export const invalidateWa = () => { cache = null; };

const trDate = (iso) => (iso ? String(iso).slice(0, 10).split("-").reverse().join(".") : "");

const dayText = (iso) => {
  if (!iso) return "";
  const end = new Date(String(iso).slice(0, 10) + "T00:00:00");
  const now = new Date(); now.setHours(0, 0, 0, 0);
  const d = Math.round((end - now) / 86400000);
  if (d === 0) return "bugün";
  return d > 0 ? `${d} gün sonra` : `${-d} gün önce`;
};

export const fillTemplate = (tpl, vars) => (tpl || "").replace(/\{(\w+)\}/g, (m, k) => (k in vars ? vars[k] ?? "" : m));

export const policyVars = (p, agency) => ({
  musteri: p.customer_name || "",
  plaka: p.plate || "",
  plaka_metin: p.plate ? `${p.plate} plakalı aracınıza ait ` : "",
  tur: p.policy_type || "",
  sirket: p.insurance_company || "",
  bitis: trDate(p.end_date),
  gun: dayText(p.end_date),
  acente: agency || "",
});

const tl = (n) => `${Number(n || 0).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} TL`;

// Muhasebe cari hesabı: borç, ek borçlar, ödemeler ve kalan
export const ledgerVars = (a, agency) => {
  const p = a.policy || {};
  const head = a.policy_id && (p.policy_type || p.start_date)
    ? `${p.start_date ? trDate(p.start_date) + " tarihli " : ""}${p.plate ? p.plate + " plakalı aracınıza ait " : ""}${p.policy_type || ""} poliçenizin`.trim()
    : "Sigorta işlemlerinize ait";
  const moves = [
    ...(a.charges || []).map((c) => ({ d: c.date, t: `• ${c.date ? trDate(c.date) + " tarihinde " : ""}${tl(c.amount)} ek borç${c.note ? ` (${c.note})` : ""}` })),
    ...(a.payments || []).map((x) => ({ d: x.date, t: `• ${x.date ? trDate(x.date) + " tarihinde " : ""}${tl(x.amount)} ödeme${x.note ? ` (${x.note})` : ""}` })),
  ].sort((x, y) => String(x.d || "").localeCompare(String(y.d || ""))).map((m) => m.t);
  const ozet = [`*Toplam Borç: ${tl(a.total_debt)}*`, ...(moves.length ? ["", ...moves] : []), "", `*Kalan Borç: ${tl(a.remaining)}*`].join("\n");
  return {
    musteri: a.customer_name || "", police_metin: head.charAt(0).toUpperCase() + head.slice(1), hesap_ozeti: ozet,
    toplam: tl(a.total_debt), odenen: tl(a.paid), kalan: tl(a.remaining),
    plaka: p.plate || "", tur: p.policy_type || "", sirket: p.insurance_company || "", acente: agency || "",
  };
};

// 05xx / 5xx / +90 5xx → 905xxxxxxxxx
export const waPhone = (phone) => {
  let d = String(phone || "").replace(/\D/g, "");
  if (d.startsWith("0")) d = d.slice(1);
  if (d.length === 10) d = "90" + d;
  return d;
};

// Mesajlar bilgisayardaki WhatsApp uygulamasında açılır (yeni sekme yok, oturum düşmez)
const launch = (url) => {
  const a = document.createElement("a");
  a.href = url;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
};

export const openWhatsApp = (phone, text) => {
  const p = waPhone(phone);
  if (isMobile()) {
    window.open(`https://wa.me/${p}?text=${encodeURIComponent(text)}`, "_blank", "noopener");
    return;
  }
  launch(`whatsapp://send?phone=${p}&text=${encodeURIComponent(text)}`);
};

export const copyText = (t) => navigator.clipboard.writeText(t);

const AUTO_KEY = "wa_autoopen";
export const isMobile = () => /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);
export const getAutoOpen = () => localStorage.getItem(AUTO_KEY) === "1";
export const setAutoOpen = (on) => localStorage.setItem(AUTO_KEY, on ? "1" : "0");

export const openWaWeb = () => {
  if (isMobile()) return !!window.open("https://wa.me/", "_blank");
  launch("whatsapp://send");
  sessionStorage.setItem("wa_opened", "1");
  return true;
};

export const autoOpenOnce = () => {
  if (!getAutoOpen() || isMobile() || sessionStorage.getItem("wa_opened")) return;
  openWaWeb();
};

export const PLACEHOLDERS = [
  ["{musteri}", "Müşteri adı"], ["{plaka}", "Plaka"], ["{plaka_metin}", "\"34ABC123 plakalı aracınıza ait \" (plaka yoksa boş)"],
  ["{tur}", "Poliçe türü"], ["{sirket}", "Sigorta şirketi"], ["{bitis}", "Bitiş tarihi"], ["{gun}", "\"12 gün sonra\" gibi"],
  ["{acente}", "Firma adınız (Raporlar ayarından)"],
  ["{police_metin}", "Açık Hesaplar: \"01.06.2026 tarihli 34ABC123 plakalı aracınıza ait Trafik poliçenizin\""],
  ["{hesap_ozeti}", "Açık Hesaplar: toplam borç, tarihli ödemeler ve kalan borç listesi"],
  ["{toplam}", "Açık Hesaplar: toplam borç"], ["{odenen}", "Açık Hesaplar: ödenen"], ["{kalan}", "Açık Hesaplar: kalan borç"],
];
